const configs = {
  local: {
    env: 'local',
    authAPI: 'https://auth.evsrv.org',
    everywhereApi: 'https://account-backend.evsrv.org',
    eventTrackingEnabled: false
  },
  development: {
    env: 'dev',
    authAPI: 'https://auth.evsrv.org',
    everywhereApi: 'https://account-backend.evsrv.org',
    eventTrackingEnabled: true
  },
  staging: {
    env: 'staging',
    authAPI: 'https://auth.evstg.org',
    everywhereApi: 'https://account-backend.evstg.org',
    eventTrackingEnabled: true
  },
  production: {
    env: 'prod',
    authAPI: 'https://auth.evprod.org',
    everywhereApi: 'https://account-backend.evprod.org',
    eventTrackingEnabled: true
  },
  demo: {
    env: 'demo',
    authAPI: 'https://auth.evsit.org',
    everywhereApi: 'https://account-backend.evsit.org',
    eventTrackingEnabled: true
  }
};

const configEnv = configs[process.env.REACT_APP_STAGE] || configs.development;

const config = {
  // Add common config values here
  ...configEnv,
  stackAdapt: {
    url: 'https://tags.srv.stackadapt.com/events.js',
    id: '7e7zoIi1nbgTMQ0CrYnAvi'
  },
  recaptchaPublicKey: '6Lcc-bMoAAAAAL8WZYBjql0hGmO5D-AW7U_F-bfG'
};

export default config;
